import type { SVGProps } from "react";

/**
 * Microsoft four-square mark icon.
 *
 * API mirrors a lucide icon: pass `className` (e.g. `size-4`) and any other
 * SVG props. Shipped locally rather than pulled in as a dependency since it's
 * the only Microsoft asset we need.
 */
export function Microsoft({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23 23"
      width="24"
      height="24"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path fill="#F25022" d="M1 1h10v10H1z" />
      <path fill="#7FBA00" d="M12 1h10v10H12z" />
      <path fill="#00A4EF" d="M1 12h10v10H1z" />
      <path fill="#FFB900" d="M12 12h10v10H12z" />
    </svg>
  );
}
